import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { CONTACT, HOMAS } from "../mock";

const Homas = () => {
  const wa = CONTACT.whatsappNumber.replace(/\D/g, "");
  return (
    <section id="homas" className="homas">
      <div className="container">
        <div className="homas-head">
          <span className="section-label center">Sacred Rituals</span>
          <h2 className="section-title">Special Homas &amp;<br/><em>Poojas</em></h2>
          <p className="section-desc" style={{ margin: "14px auto 0" }}>
            Ancient Vedic fire rituals and worship ceremonies performed to invoke divine
            blessings for specific life goals.
          </p>
        </div>

        <div className="homas-grid">
          {HOMAS.map((h) => (
            <div className="homa-card" key={h.num}>
              <div className="homa-card-img">
                <img src={h.img} alt={h.title} loading="lazy" />
                <div className="homa-num">{h.num}</div>
              </div>
              <div className="homa-card-body">
                <span className="tag">{h.tag}</span>
                <h3>{h.title}</h3>
                <p>{h.desc}</p>
                <div className="homa-actions">
                  <a href={`tel:${CONTACT.callNumber}`} className="btn btn-call"><Phone size={14}/> Call Now</a>
                  <a href={`https://wa.me/${wa}?text=Hi Guruji, I would like to book ${encodeURIComponent(h.title)}`} target="_blank" rel="noreferrer" className="btn btn-wa"><MessageCircle size={14}/> WhatsApp</a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Homas;
